/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=65bff0b4"
const script = {}

import exportComponent from "/Users/neo/Desktop/github.com/liuzemei/gongdehui-client2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__